<template>
  <div class="review-area">
    <div v-if="formData[userName]" class="flex flex-column read-only-box">
      <div>
        <slot v-if="$slots.title" name="title"></slot>
        <div v-else>{{ title }}：</div>
        <el-tag :type="formData[status]===0?'danger':(formData[status]===1?'success':'info')">
          {{ getReviewName(formData[status]) }}
        </el-tag>
      </div>
      <div class="flex-1"> {{ formData[opinion] }}</div>
      <div>
        签字：{{formData[userName]  }}
        <span class="ml-1 signature-date" style="font-size: 15px;"> {{ formData[signTime] | formatDate('YYYY 年 MM 月 DD 日 HH 时 mm 分') }}
      </span>
      </div>
    </div>
    <div v-else>
      <div>
        <slot v-if="$slots.title" name="title"></slot>
        <div v-else>{{ title }}：</div>
        <span style="font-weight: bold">审核结果：</span>
        <el-form-item :prop="status">
          <el-select v-model="formData[status]" :disabled="formData.filterType !== filterType" size="mini"
                     style="width:100px;">
            <el-option :value="0" label="不通过" />
            <el-option :value="1" label="通过" />
          </el-select>
        </el-form-item>
      </div>
      <el-form-item :prop="opinion">
      <el-input type="textarea" rows="3" style="height: 100px;width: 100%"
                maxlength="200"
                v-model="formData[opinion]"
                :disabled="formData.filterType !== filterType" />
      </el-form-item>
      <div v-if="formData.filterType===filterType" class="mt-1">
        <div >签字：{{ $store.state.login.userInfo.realName }}
          <span class="ml-1" style="font-size: 15px;"> {{ $moment().format('YYYY 年 MM 月 DD 日')}}
      </span>
        </div>
      </div>
      <div v-else class="mt-1">
        <div>签字：
          <span class="ml-1"
                style="font-size: 15px;"><i style="padding-left: 6em;"></i>年<i style="padding-left: 2em;"></i>月<i style="padding-left: 2em;"></i>日</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reviewArea',
  props: {
    title: String,
    status: String, // 审核结果
    opinion: String, // 审核意见
    userName: String, // 审核人
    signTime: String, // 审核时间
    filterType: Number, // 判断是否为当前角色审批
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {}
  },
  methods: {
    getReviewName (status) {
      if (status === 0 || status === '0') {
        return '审批不通过'
      } else if (status === 1 || status === '1') {
        return '审批通过'
      } else {
        return '待审批'
      }
    }
  }
}
</script>

<style lang="scss">
.review-area {
  height: 100%;
  .read-only-box {
    padding: 10px 0;
    height: 100%;
    box-sizing: border-box;
  }
}
</style>
